import { connect } from "react-redux";
import get from "lodash/get";

import {
  selectToChangeUnit as onSelectToChangeUnit,
  clearToChangeUnit as onClearToChangeUnit,
  updateUnitSupport as onUpdateUnitSupport,
  unitShared as onUnitShared,
  unitUnShared as onUnitUnShared,
  getUnitSettings as onGetUnitSettings,
  updatgeUnitSetting as onUpdatgeUnitSetting,
  updatgeUnitInformation as onUpdatgeUnitInformation,
} from "../../actions/unitActions";

const mapStateToProps = (state) => ({
  changeUnitDataState: state.currentUnit.changeUnitDataState,
  changeUnitSharedDataState: state.currentUnit.changeUnitSharedDataState,
  unitSettingsDataState: state.currentUnit.unitSettingsDataState,
  updateUnitSettingDataState: state.currentUnit.updateUnitSettingDataState,
  updateUnitInformationDataState: state.currentUnit.updateUnitInformationDataState,
  currentUnit: get(state, ["currentUnit", "currentUnit"], null),
  unitSettings: get(state, ["currentUnit", "unitSettings"], { settingsGroups: [] }),
  errors: get(state, ["currentUnit", "errors"], []),
});

const mapDispatchToProps = {
  onSelectToChangeUnit,
  onClearToChangeUnit,
  onUpdateUnitSupport,
  onUnitShared,
  onUnitUnShared,
  onGetUnitSettings,
  onUpdatgeUnitSetting,
  onUpdatgeUnitInformation,
};

const withUnits = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withUnits };
